import React, { useEffect, useState } from "react";
import Sidebar from "../../components/SideBar";
import Navbar from "../../components/NavBar";
import "./Dashboard.css";

import {
  getBloodPressureMeasurements,
  getBloodPressureMeasurementsPerDate,
  getBloodPressureNotifications,
  getChatbotInteractions,
  getChatbotInteractionsPerDate,
  getDrugAssumptionNotifications,
  getTotalIntakeLogs,
  getEducationalNotifications
} from "../../../service-layer/AdminService";

import { CButton, CCard, CCol, CFormInput, CRow, CDropdownMenu, CDropdownToggle, CDropdownItem, CDropdown } from "@coreui/react";
import { Line } from "react-chartjs-2";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

// DOWNLOAD CSV
import JSZip from "jszip";
import { saveAs } from "file-saver";
// CONVERSION TO EXCEL IMPORT
import * as XLSX from 'xlsx';

// REACT SPINNER
import ClipLoader from "react-spinners/ClipLoader";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getActiveDoctorCount } from "../../../service-layer/MedicalStaffService";
import { getActivePatientsCount } from "../../../service-layer/PatientService";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { FaInfoCircle } from "react-icons/fa";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import LogoutModal from "../../components/logout-moal/LogoutModal";

dayjs.extend(isBetween);

export const DashboardAdmin = () => {
  const { t } = useTranslation();
  const [totalChatbotInteractions, setTotalChatbotInteractions] = useState(0);
  const [
    totalChatbotInteractionsInTheRangeOfDates,
    setTotalChatbotInteractionsInTheRangeOfDates,
  ] = useState(0);
  const [
    pressureInsertionsInTheRangeOfDate,
    setPressureInsertionsInTheRangeOfDate,
  ] = useState(0);
  const [totalPressureInsertions, setTotalPressureInsertions] = useState(0);
  const [numberOfSearch, setNumberOfSearch] = useState(0);
  const [singlePressureInsertions, setSinglePressureInsertions] = useState([]);
  const [
    monthlyChatbotInteractionsInTheRangeOfDates,
    setMonthlyChatbotInteractionsInTheRangeOfDates,
  ] = useState([]);
  const [totalMonthlyChatbotInteractions, setTotalMonthlyChatbotInteractions] =
    useState([]);
  const [
    monthlyInsertionsInTheRangeOfDates,
    setMonthlyInsertionsInTheRangeOfDates,
  ] = useState([]);
  const [totalMonthlyInsertions, setTotalMonthlyInsertions] = useState([]);
  const [maxInteractions, setMaxInteractions] = useState(0);
  const [minInteractions, setMinInteractions] = useState(0);
  const [maxInsertions, setMaxInsertions] = useState(0);
  const [minInsertions, setMinInsertions] = useState(0);
  const [therapyAdherence, setTherapyAdherence] = useState(0);
  const [totalNotifications, setTotalNotifications] = useState(0);
  const [allInteractions, setAllInteractions] = useState([]);
  const [allInsertions, setAllInsertions] = useState([]);
  const [allInteractionsPerDate, setAllInteractionsPerDate] = useState([]);
  const [allInsertionsPerDate, setAllInsertionsPerDate] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalDoctors, setTotalDoctors] = useState(0);
  const [totalPatients, setTotalPatients] = useState(0);
  const [last7daysInteractions, setLast7daysInteractions] = useState([]);
  const [last7daysInsertions, setLast7daysInsertions] = useState([]);
  const [last30daysInteractions, setLast30daysInteractions] = useState([]);
  const [last30daysInsertions, setLast30daysInsertions] = useState([]);

  // NOTIFICHE EDUCATIVE
  const [totalEducationalNotifications, setTotalEducationalNotifications] = useState(0)
  const [loadingTotalEducationalNotifications, setLoadingTotalEducationalNotifications] = useState(true)

  const currentDate = dayjs();
  const threeMonthsAgo = currentDate.subtract(4, "month");
  const formattedEndDate = currentDate.format("YYYY-MM-DD");
  const formattedStartDate = threeMonthsAgo.format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(formattedStartDate);
  const [endDate, setEndDate] = useState(formattedEndDate);
  const [hasError, setHasError] = useState(false);
  const [correctAssumptions, setCorrectAssumptions] = useState(0);
  const [emptyInteraction, setEmptyInteraction] = useState(false);
  const [emptyInsertion, setEmptyInsertion] = useState(false);
  const [interactionData, setInteractionData] = useState({
    labels: [],
    datasets: [
      {
        label: "Chatbot interactions",
        data: [],
        fill: false,
        backgroundColor: "#204770",
        borderColor: "#204770",
        borderWidth: 2,
        pointRadius: 2,
        tension: 0.2,
      },
    ],
  });

  const [insertionData, setInsertionData] = useState({
    labels: [],
    datasets: [
      {
        label: "Chatbot interactions",
        data: [],
        fill: false,
        backgroundColor: "#204770",
        borderColor: "#204770",
        borderWidth: 2,
        pointRadius: 2,
        tension: 0.2,
      },
    ],
  });

  const interactionOptions = {
    plugins: {
      legend: {
        display: true,
      },
      title: {
        text: t("ChatbotInteractions"),
        display: true,
        padding: 10,
        font: {
          size: "14px",
        },
      },
    },
    maintainAspectRatio: false,
    scales: {
      x: {
        border: {
          display: true,
        },
        grid: {
          display: true,
          drawOnChartArea: false,
        },
        ticks: {
          callback: function (val, index) {
            if (index % 2 === 0) {
              let new_value = this.getLabelForValue(val);
              const [day, month] = new_value.split(" ");
              return day + " " + month.slice(0, 3);
            } else return "";
          },
          maxRotation: 0,
          minRotation: 0,
        },
      },
      y: {
        // min: minInteractions,
        // max: maxInteractions,
        display: true,
        grid: {
          display: true,
        },
        ticks: {
          display: true,
        },
      },
    },
    elements: {
      line: {
        borderWidth: 1,
        tension: 0.4,
      },
      point: {
        radius: 4,
        hitRadius: 10,
        hoverRadius: 4,
      },
    },
  };
  const insertionOptions = {
    plugins: {
      legend: {
        display: true,
      },
      title: {
        text: t("bloodPressureInsertions"),
        display: true,
        padding: 10,
        font: {
          size: "14px",
        },
      },
    },
    maintainAspectRatio: false,
    scales: {
      x: {
        border: {
          display: true,
        },
        grid: {
          display: true,
          drawOnChartArea: false,
        },
        ticks: {
          callback: function (val, index) {
            if (index % 2 === 0) {
              let new_value = this.getLabelForValue(val);
              const [day, month] = new_value.split(" ");
              return day + " " + month.substring(0, 3);
            } else return "";
          },
          maxRotation: 0,
          minRotation: 0,
        },
      },
      y: {
        // min: minInteractions,
        // max: maxInteractions,
        display: true,
        grid: {
          display: true,
        },
        ticks: {
          display: true,
        },
      },
    },
    elements: {
      line: {
        borderWidth: 1,
        tension: 0.4,
      },
      point: {
        radius: 4,
        hitRadius: 10,
        hoverRadius: 4,
      },
    },
  };

  // LOADING STATES
  const [loadingInteractions, setLoadingInteractions] = useState(true);
  const [loadingInsertions, setLoadingInsertions] = useState(true);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const handleConfirm = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("name");
    localStorage.removeItem("surname");
    localStorage.removeItem("authority");
    setShowLogoutModal(false);
    navigate("/");
  };

  const [loadingTotalInteractions, setLoadingTotalInteractions] =
    useState(true);
  const [loadingTotalInsertions, setLoadingTotalInsertions] = useState(true);

  const [loadingTotalUsers, setLoadingTotalUsers] = useState(true);
  const [loadingTotalNotifications, setLoadingTotalNotifications] =
    useState(true);
  const [loadingAdherence, setLoadingAdherence] = useState(true);

  // DAYS DIFFERENCE
  const [
    interactionsDaysDifferenceInTheRangeOfDate,
    setInteractionDaysDifferenceInTheRangeOfDate,
  ] = useState(undefined);

  const [totalInteractionsDaysDifference, setTotalInteractionsDaysDifference] =
    useState(undefined);

  const [
    insertionsDaysDifferenceInTheRangeOfDate,
    setInsertionsDaysDifferenceInTheRangeOfDate,
  ] = useState(undefined);

  const [totalInsertionsDaysDifference, seTotalInsertionsDaysDifference] =
    useState(undefined);

  const token = window.localStorage.getItem("auth_token");
  const navigate = useNavigate();

  useEffect(() => {
    if (window.localStorage.getItem("auth_token") === null) navigate("/login");

    console.log("this is the token" + token);
  }, [navigate]);

  /*useEffect(() => {
          console.log("Monthly interactions in the range of dates", monthlyChatbotInteractionsInTheRangeOfDates);
          console.log("total monthly interactions", totalMonthlyChatbotInteractions);
  
          console.log("total interactions", totalChatbotInteractions);
          console.log("total interactions in the range of dates", totalChatbotInteractionsInTheRangeOfDates);
  
          console.log("total difference days", totalInteractionsDaysDifference);
          console.log("difference days in the range", interactionsDaysDifferenceInTheRangeOfDate);
      }, [monthlyChatbotInteractionsInTheRangeOfDates, totalMonthlyChatbotInteractions, totalChatbotInteractions, totalChatbotInteractionsInTheRangeOfDates]);*/

  const updateChatbotData = (messages_list) => {
    // Step 1: Group messages by day
    const messagesByDay = messages_list.reduce((acc, message) => {
      // Extract and format the date as "DD MMM" (e.g., "18 May")
      const messageDate = dayjs(message.messageDateTime).format("MMM DD");
      if (acc[messageDate]) {
        acc[messageDate] += 1;
      } else {
        acc[messageDate] = 1;
      }

      return acc;
    }, {});

    // Step 2: Prepare data for the chart
    const labels = Object.keys(messagesByDay); // Dates formatted as "DD MMM"
    const dataValues = Object.values(messagesByDay); // Number of interactions per day

    const data = {
      labels: labels, // X-axis labels (formatted dates)
      datasets: [
        {
          label: t("interactions"),
          data: dataValues, // Y-axis data (message counts per day)
          backgroundColor: "#204770",
          borderColor: "#204770",
          borderWidth: 2,
          pointRadius: 2,
          tension: 0.2,
          fill: false,
        },
      ],
    };
    setInteractionData(data);
    setTotalChatbotInteractionsInTheRangeOfDates(messages_list.length);

    // numero totale di messaggi per ogni mese
    monthlyInteractionsHandler(
      messages_list,
      setMonthlyChatbotInteractionsInTheRangeOfDates,
      setInteractionDaysDifferenceInTheRangeOfDate,
    );

    // interazioni negli ultimi 7 giorni
    lastDaysEvents(messages_list, 7, 1);
    lastDaysEvents(messages_list, 30, 1);
  };

  const updateMeasurementData = (
    totalMeasurements,
    setPressureInsertions,
    tag,
  ) => {
    let totalPressureInsertions = [];
    console.log(
      "TOTAL MEASUREMENTS---------------------------------->",
      totalMeasurements,
    );

    if (tag === "perDate") {
      // Step 1: Group messages by day
      const insertionByDay = totalMeasurements.reduce((acc, mes) => {
        // Extract and format the date as "DD MMM" (e.g., "18 May")
        const insertionDate = dayjs(mes.measurementDate).format("MMM DD");
        if (acc[insertionDate]) {
          acc[insertionDate] += 1;
        } else {
          acc[insertionDate] = 1;
        }

        return acc;
      }, {});
      console.log("insertion by days----------------------->", insertionByDay);

      // Step 2: Prepare data for the chart
      const labels = Object.keys(insertionByDay); // Dates formatted as "DD MMM"
      const dataValues = Object.values(insertionByDay); // Number of interactions per day

      const data = {
        labels: labels, // X-axis labels (formatted dates)
        datasets: [
          {
            label: t("insertions"),
            data: dataValues, // Y-axis data (message counts per day)
            backgroundColor: "#204770",
            borderColor: "#204770",
            borderWidth: 2,
            pointRadius: 2,
            tension: 0.2,
            fill: false,
          },
        ],
      };
      monthlyPressureInsertionsHandler(
        totalMeasurements,
        setInsertionsDaysDifferenceInTheRangeOfDate,
        setMonthlyInsertionsInTheRangeOfDates,
      );
      setInsertionData(data);
    } else if (tag === "total") {
      monthlyPressureInsertionsHandler(
        totalMeasurements,
        seTotalInsertionsDaysDifference,
        setTotalMonthlyInsertions,
      );
    }

    for (let i = 0; i < totalMeasurements.length - 1; i++) {
      totalMeasurements[i].measurementDate = transformDate(
        totalMeasurements[i].measurementDate,
      ); // tolgo millisecondi perché alcuni inserimenti hanno piccole latenze
      totalMeasurements[i + 1].measurementDate = transformDate(
        totalMeasurements[i + 1].measurementDate,
      );
      if (
        ((totalMeasurements[i].measurementId == 11 &&
          totalMeasurements[i + 1].measurementId == 12) ||
          (totalMeasurements[i].measurementId == 12 &&
            totalMeasurements[i + 1].measurementId == 11)) &&
        totalMeasurements[i].measurementDate ===
          totalMeasurements[i + 1].measurementDate &&
        totalMeasurements[i].userId === totalMeasurements[i + 1].userId
      ) {
        totalPressureInsertions.push({
          userId: totalMeasurements[i].userId,
          measurementDate: totalMeasurements[i].measurementDate,
          maxPressure:
            totalMeasurements[i].measurementId === 12
              ? totalMeasurements[i].measurementValue
              : totalMeasurements[i + 1].measurementValue,
          minPressure:
            totalMeasurements[i].measurementId === 11
              ? totalMeasurements[i].measurementValue
              : totalMeasurements[i + 1].measurementValue,
        });
        i += 1;
      } else {
        totalPressureInsertions.push({
          userId: totalMeasurements[i].userId,
          measurementDate: totalMeasurements[i].measurementDate,
          maxPressure:
            totalMeasurements[i].measurementId === 12
              ? totalMeasurements[i].measurementValue
              : -1,
          minPressure:
            totalMeasurements[i].measurementId === 11
              ? totalMeasurements[i].measurementValue
              : -1,
        });
      }
    }
    console.log("TOTAL PRESSURE INSERTIONS", totalPressureInsertions);

    if (tag === "total") {
      setSinglePressureInsertions(totalPressureInsertions);
    }

    // numero totale inserimenti
    setPressureInsertions(totalPressureInsertions.length);
    setLoadingInsertions(false);
  };

  useEffect(() => {
    setLoadingTotalInteractions(true);
    getChatbotInteractions()
      .then((response) => {
        setAllInteractions(response.data)
        monthlyInteractionsHandler(
          response.data,
          setTotalMonthlyChatbotInteractions,
          setTotalInteractionsDaysDifference,
        );
        lastDaysEvents(response.data, 7, 2);
        lastDaysEvents(response.data, 30, 2);
        setTotalChatbotInteractions(response.data.length);
        setLoadingTotalInteractions(false);
      })
      .catch((err) => {
        console.log(err);
      });

    setLoadingTotalInsertions(true);
    getBloodPressureMeasurements()
      .then((response) => {
        setAllInsertions(response.data)
        console.log("NOT PER DATE--------------->", response);
        updateMeasurementData(
          response.data,
          setTotalPressureInsertions,
          "total",
        );
        setLoadingTotalInsertions(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    setLoadingInteractions(true);
    getChatbotInteractionsPerDate(startDate, endDate).then((response) => {
      if (response.data.length === 0) {
        setEmptyInteraction(true);
      } else {
        setAllInteractionsPerDate(response.data)
        updateChatbotData(response.data);
        setEmptyInteraction(false);
      }
      setLoadingInteractions(false);
      console.log("response per date--------------->", response);
    });

    setLoadingInsertions(true);
    getBloodPressureMeasurementsPerDate(startDate, endDate).then((response) => {
      if (response.data.length === 0) {
        setEmptyInsertion(true);
        console.log("empty----------------------------------------");
      } else {
        setAllInsertionsPerDate(response.data)
        updateMeasurementData(
          response.data,
          setPressureInsertionsInTheRangeOfDate,
          "perDate",
        );
        setEmptyInsertion(false);
      }
      console.log("PER DATE--------------->", response);
      setLoadingInsertions(false);
    }).catch(() => {
      setShowLogoutModal(true);
    });
  }, [numberOfSearch]);

  useEffect(() => {
    getDrugAssumptionNotifications().then((response) => {
      const total_notifications = response.data.length
      console.log("TOTAL NOTIFICATIONS", response.data)
      if (response.status === 200) {
        getTotalIntakeLogs().then((res) => {
          if(res.status === 200)
            calculateAdherence(res.data, total_notifications);
        })
      }
    });
  }, []);

  // EDUCATIONAL NOTIFICATIONS
  useEffect(() => {
    getEducationalNotifications().then(res => {
      setTotalEducationalNotifications(res.data.length)
      setLoadingTotalEducationalNotifications(false)
    })
  }, [])

  useEffect(() => {
    getActiveDoctorCount().then((response) => {
      console.log("TOTAL DOCTORSSS", response.data)
      if (response.status === 200) {
        setTotalDoctors(response.data);
      }
    });
  }, []);

  useEffect(() => {
    getActivePatientsCount().then((response) => {
      if (response.status === 200) {
        setTotalPatients(response.data);
      }
    });
  }, []);

  useEffect(() => {
    setTotalUsers(totalDoctors + totalPatients);
  }, [totalDoctors, totalPatients]);

  function calculateAdherence(correct_assumptions, total) {
    let user_correct_assumptions = correct_assumptions.length;

    console.log("CORRECT ASSUMPTIONS", user_correct_assumptions)

    setTotalNotifications(total);
    setTherapyAdherence(100 * (user_correct_assumptions / total));
    setCorrectAssumptions(user_correct_assumptions);

    setLoadingAdherence(false);
    setLoadingTotalUsers(false);
    setLoadingTotalNotifications(false);
  }

  function monthlyInteractionsHandler(
    messages,
    setInteractions,
    setDifferenceDays,
  ) {
    let monthly_messages = [];

    const oldest_date = new Date(messages[0].messageDateTime);
    let oldest_month = oldest_date.getMonth() + 1;
    let oldest_year = oldest_date.getFullYear();

    const recent_date = new Date(messages[messages.length - 1].messageDateTime);
    let recent_month = recent_date.getMonth() + 1;
    let recent_year = recent_date.getFullYear();

    const diffInDays = daysDifference(oldest_date, recent_date);
    setDifferenceDays(diffInDays);

    const total_months =
      (recent_year - oldest_year) * 12 + (recent_month - oldest_month) + 1;

    let current_year = oldest_year;
    let current_month = oldest_month;

    for (let i = 0; i < total_months; i++) {
      // eslint-disable-next-line no-loop-func
      let message_count = messages.filter((message) => {
        const message_time = new Date(message.messageDateTime);
        let message_month = message_time.getMonth() + 1;
        let message_year = message_time.getFullYear();

        if (message_month === current_month && message_year === current_year)
          return true;
        else return false;
      }).length;

      monthly_messages.push({
        id: i,
        messages: message_count,
        month: `${getMonthString(current_month)} `,
        year: `${current_year}`,
      });

      if (current_month === 12) {
        current_month = 1;
        current_year += 1;
      } else current_month += 1;
    }

    console.log("MONTHLY MESSAGES-------", monthly_messages);
    setInteractions(monthly_messages);
    let messages_number = monthly_messages.map((m) => m.messages);
    setMinInteractions(Math.min(...messages_number));
    setMaxInteractions(Math.max(...messages_number));
  }

  function monthlyPressureInsertionsHandler(
    insertions,
    setInsertionsDaysDifference,
    setMonthlyInsertions,
  ) {
    let monthly_insertions = [];
    const oldest_date = new Date(insertions[0].measurementDate);
    let oldest_month = oldest_date.getMonth() + 1;
    let oldest_year = oldest_date.getFullYear();
    console.log();

    const recent_date = new Date(
      insertions[insertions.length - 1].measurementDate,
    );
    let recent_month = recent_date.getMonth() + 1;
    let recent_year = recent_date.getFullYear();

    const diffInDays = daysDifference(oldest_date, recent_date);
    setInsertionsDaysDifference(diffInDays);

    const total_months =
      (recent_year - oldest_year) * 12 + (recent_month - oldest_month) + 1;

    console.log("TOTAL MONTH", total_months);
    console.log("OLDEST YEAR", recent_year);
    console.log("RECENT YEAR", oldest_year);

    let current_year = oldest_year;
    let current_month = oldest_month;

    for (let i = 0; i < total_months; i++) {
      let insertion_count = insertions.filter((insertion) => {
        const insertion_time = new Date(insertion.measurementDate);
        let insertion_month = insertion_time.getMonth() + 1;
        let insertion_year = insertion_time.getFullYear();

        if (
          insertion_month === current_month &&
          insertion_year === current_year
        )
          return true;
        else return false;
      }).length;

      monthly_insertions.push({
        id: i,
        insertions: insertion_count,
        month: `${getMonthString(current_month)} `,
        year: `${current_year} `,
      });

      if (current_month === 12) {
        current_month = 1;
        current_year += 1;
      } else current_month += 1;
    }

    console.log("MONTHLY INSERTIONS", monthly_insertions);

    setMonthlyInsertions(monthly_insertions);
    let monthly_insertions_number = monthly_insertions.map(
      (m) => m.measurementDate,
    );
    setMinInsertions(Math.min(...monthly_insertions_number));
    setMaxInsertions(Math.max(...monthly_insertions_number));
  }

  function lastDaysEvents(event, days, type) {
    const now = new Date();
    let events = [];
    if (type === 1)
      events = event
        .filter(
          (ev) =>
            Math.abs(new Date(ev.messageDateTime) - now) <= 86400000 * days,
        )
        .map((ev) => {
          return { ...ev, eventDateTime: ev.messageDateTime };
        });
    else if (type === 2)
      events = event
        .filter(
          (ev) =>
            Math.abs(new Date(ev.measurementDate) - now) <= 86400000 * days,
        )
        .map((ev) => {
          return { ...ev, eventDateTime: ev.measurementDate };
        });
    //console.log("WEEK EVENTS", week_events)

    // assegno giorno specifico
    events = events.map((ev) => {
      let date = new Date(ev.eventDateTime);
      let day = date.getDate();
      let month = getMonthString(date.getMonth() + 1);

      const day_string = `${month} ${day < 10 ? "0" + day : day}`;

      return {
        day: day_string,
      };
    });

    let days_events = events
      .map((ev) => ev.day)
      .filter((ev, ind, arr) => arr.indexOf(ev) === ind);

    days_events = days_events.map((day) => {
      let day_events = events.filter((ev) => ev.day === day).length;

      return {
        day: day,
        events: day_events,
      };
    });

    //console.log("7 DAYS EVENTS", days_events)
    let last_days = [];
    for (let i = 0; i < days; i++) {
      let day = new Date();
      day.setDate(day.getDate() - i);
      let day_string = `${getMonthString(day.getMonth() + 1)} ${day.getDate() > 9 ? day.getDate() : "0" + day.getDate()}`;

      let day_events = days_events.filter((day) => day.day === day_string);
      //console.log("7 DAYS EVENTS", day_string)

      last_days.push({
        day: day_string,
        events: day_events.length > 0 ? day_events[0].events : 0,
      });
    }

    last_days.reverse();
    //console.log("LAST DAYS", last_days)
    if (type === 1 && days === 7) setLast7daysInteractions(last_days);
    else if (type === 2 && days === 7) setLast7daysInsertions(last_days);
    if (type === 1 && days === 30) setLast30daysInteractions(last_days);
    else if (type === 2 && days === 30) setLast30daysInsertions(last_days);
  }

  function transformDate(dateTime) {
    // const date = new Date(dateTime)
    // let dateTimeString = date.toISOString()
    const timestamp = dateTime.split(".")[0];

    return timestamp;
  }

  function daysDifference(start, end) {
    const startDate = new Date(start);
    const endDate = new Date(end);

    // Get the difference in milliseconds
    const diffInMs = Math.abs(endDate - startDate);

    // Convert milliseconds to days
    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));


    return diffInDays;
  }

  function getMonthString(month) {
    const month_names = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    return month_names[month - 1];
  }

  // FUNZIONi PER SALVARE I DATI IN FORMATO CSV
  // async function downloadCSVFilesAsZip(files) {
  //   const zip = new JSZip();
  //   files.forEach((file) => {
  //     const csvContent = convertToCSV(file.data);
  //     zip.file(`${file.filename}.csv`, csvContent);
  //   });

  //   const content = await zip.generateAsync({ type: "blob" });
  //   saveAs(content, "admin_data.zip");
  // }

  // function convertToCSV(data) {
  //   const headers = Object.keys(data[0]);
  //   const csvRows = data.map((row) =>
  //     headers.map((header) => JSON.stringify(row[header], replacer)).join(";"),
  //   );
  //   csvRows.unshift(headers.join(";")); // add header row at the beginning
  //   return csvRows.join("\n");
  // }

  // function replacer(key, value) {
  //   return value === null ? "" : value;
  // }

  // function prepareDataForCSV() {
  //   // IN THIS FORMAT
  //   // const files = [
  //   /*
  //                                                                 {
  //                                                                    filename: 'file1',
  //                                                                    data: [
  //                                                                      { name: 'John', age: 30, city: 'New York' },
  //                                                                      { name: 'Jane', age: 25, city: 'San Francisco' },
  //                                                                    ],
  //                                                                 },
  //                                                                ]
  //                                                               */
  //   let files = [];
  //   // preparazione dati semplici (con un solo valore)
  //   // DATI SU MEDIE MENSILI/GIORNALIERE/TOTALE degli eventi di inserimento e delle interazioni col chatbot
  //   const data1 = [
  //     {
  //       name: "Chatbot interactions",
  //       total_events: totalChatbotInteractions,
  //       monthly_average: (
  //         totalChatbotInteractions /
  //         totalMonthlyChatbotInteractions.length
  //       ).toFixed(2),
  //       daily_average: (
  //         totalChatbotInteractions / totalInteractionsDaysDifference
  //       ).toFixed(2),
  //     },
  //     {
  //       name: "Blood pressure insertions",
  //       total_events: totalPressureInsertions,
  //       monthly_average: (
  //         totalPressureInsertions /
  //         totalMonthlyInsertions.length
  //       ).toFixed(2),
  //       daily_average: (
  //         totalPressureInsertions /
  //         totalInsertionsDaysDifference
  //       ).toFixed(2),
  //     },
  //   ];

  //   files.push({
  //     filename: "events_summary_info",
  //     data: data1,
  //   });

  //   console.log("INSERTIONS", insertionData)

  //   let data_2 = []

  //   insertionData['labels'].forEach((label, index) => {
  //     let label_name = label.replace(' ','_')
  //     data_2.push({
  //       date: label_name,
  //       value: insertionData['datasets'][0]['data'][index]
  //     })
  //   })

  //   files.push({
  //     filename: "insertions_in_range_dates",
  //     data: data_2,
  //   });
    
  //   let data_3 = []

  //   interactionData['labels'].forEach((label, index) => {
  //     let label_name = label.replace(' ','_')
  //     data_3.push({
  //       date: label_name,
  //       value: interactionData['datasets'][0]['data'][index]
  //     })
  //   })

  //   files.push({
  //     filename: "interactions_in_range_dates",
  //     data: data_3,
  //   });

  //   // INFO SULL'ADERENZA
  //   const data4 = [
  //     {
  //       total_patients: totalPatients,
  //       total_doctors: totalDoctors,
  //       total_notifications: totalNotifications,
  //       correctAssumptions: correctAssumptions,
  //       adherence: therapyAdherence === 'N/A' ? '' : therapyAdherence.toFixed(2),
  //     },
  //   ];
  //   files.push({
  //     filename: "adherence_users_info",
  //     data: data4,
  //   });

  //   console.log("FILE CSV", files);
  //   downloadCSVFilesAsZip(files);
  // }

  const downloadExcel =  () => {

    let sheet_1 = []
    sheet_1.push([
      t("totalChatbotInteractions").replaceAll(' ','_'),
      t("monthlyAverageInteractions").replaceAll(' ','_'),
      t("dailyAverageInteractions").replaceAll(' ','_'),
      t("totalBloodPressureInsertions").replaceAll(' ','_'),
      t("monthlyAverageInsertions").replaceAll(' ','_'),
      t("dailyAverageInsertions").replaceAll(' ','_'),
      t("totalPatients").replaceAll(' ','_'),
      t("totalDoctors").replaceAll(' ','_'),
      t("totalEducationalNotifications").replaceAll(' ','_'),
      t("respectedAssumptions").replaceAll(' ','_'),
      t("therapyAdherence").replaceAll(' ','_')
    ])
    sheet_1.push([
        totalChatbotInteractions,
        totalChatbotInteractions / totalMonthlyChatbotInteractions.length,
        totalChatbotInteractions / totalInteractionsDaysDifference,
        totalPressureInsertions,
        totalPressureInsertions / totalMonthlyInsertions.length,
        totalPressureInsertions / totalInsertionsDaysDifference,
        totalPatients,
        totalDoctors,
        totalEducationalNotifications,
        correctAssumptions,
        Number(therapyAdherence)
    ])


    // console.log("allInsertions", allInsertions)
    // console.log("allInsertionsPerDate", allInsertionsPerDate)
    // console.log("allInteractions", allInteractions)
    // console.log("allInserionsPerDate", allInteractionsPerDate)


    // 2) INSERIMENTI PRESSORI PER OGNI GIORNO
    // 3) INSERIMENTI PRESSORI PER OGNI GIORNO NEL RANGE DI DATE
    const allInsertionsNumber =  getNumberofDailyEvents(allInsertions)
    const allInsertionsPerDateNumber =  getNumberofDailyEvents(allInsertionsPerDate)
    let sheet_2 = []
    let sheet_3 = []
    sheet_2.push([
      t("date").replaceAll(' ','_'),
      t("insertions").replaceAll(' ','_')
    ])
    sheet_3.push([
      t("date").replaceAll(' ','_'),
      t("insertions").replaceAll(' ','_')
    ])

    for(let i=0; i<allInsertionsNumber.length; i++){
      const date = allInsertionsNumber[i].eventDate
      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear()
      sheet_2.push([
        date,
        allInsertionsNumber[i].events
      ])
    }

    for(let i=0; i<allInsertionsPerDateNumber.length; i++){
      const date = allInsertionsPerDateNumber[i].eventDate
      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear()
      sheet_3.push([
        date,
        allInsertionsPerDateNumber[i].events
      ])
    }


    // 4) INTERAZIONI PER OGNI GIORNO
    // 5) INTERAZIONI PER OGNI GIORNO NEL RANGE DI DATE

    const allInteractionsNumber = getNumberofDailyEvents(allInteractions, true)
    const allInteractionsPerDateNumber = getNumberofDailyEvents(allInteractionsPerDate, true)
    let sheet_4 = []
    let sheet_5 = []
    sheet_4.push([
      t("date").replaceAll(' ','_'),
      t("interactions").replaceAll(' ','_')
    ])
    sheet_5.push([
      t("date").replaceAll(' ','_'),
      t("interactions").replaceAll(' ','_')
    ])

    for(let i=0; i<allInteractionsNumber.length; i++){
      const date = allInteractionsNumber[i].eventDate
      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear()
      sheet_4.push([
        date,
        allInteractionsNumber[i].events
      ])
    }

    for(let i=0; i<allInteractionsPerDateNumber.length; i++){
      const date = allInteractionsPerDateNumber[i].eventDate
      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear()
      sheet_5.push([
        date,
        allInteractionsPerDateNumber[i].events
      ])
    }

    // Create sheets
    const ws1 = XLSX.utils.aoa_to_sheet(sheet_1);
    const ws2 = XLSX.utils.aoa_to_sheet(sheet_2);
    const ws3 = XLSX.utils.aoa_to_sheet(sheet_3);
    const ws4 = XLSX.utils.aoa_to_sheet(sheet_4);
    const ws5 = XLSX.utils.aoa_to_sheet(sheet_5);

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Append sheets to workbook
    XLSX.utils.book_append_sheet(wb, ws1, t("generalInformation"));
    XLSX.utils.book_append_sheet(wb, ws2, t("insertionsExcel"));
    XLSX.utils.book_append_sheet(wb, ws3, t("insertionsRangeExcel"));
    XLSX.utils.book_append_sheet(wb, ws4, t("interactionsExcel"));
    XLSX.utils.book_append_sheet(wb, ws5, t("interactionsRangeExcel"));

    // Export the workbook
    XLSX.writeFile(wb, `admin_data.xlsx`);
  }

  const downloadPDF = () => {
    console.log("DOWNLOADING PDF FILE")
  }

  const getNumberofDailyEvents= (values, eventType = false) => {
    let eventDate = undefined
    if(!eventType)
      eventDate = 'measurementDate'
    else
      eventDate = 'messageDateTime'

    const event_dates = values.map(val => {
      const day = new Date(val[eventDate]).getDate()
      const month = new Date(val[eventDate]).getMonth() + 1
      const year = new Date(val[eventDate]).getFullYear()

      return new Date(`${year}-${month}-${day}`)
    })

    const unique_dates = event_dates.filter((d, ind, arr) => {
      if(ind === 0)
        return true
      else{
        if(arr[ind].getDate() !== arr[ind-1].getDate())
          return true
        else
          return false
      }
    })

    const events_per_date = unique_dates.map((date) => {
      const targetDate = new Date(date);
      const events_array = values.filter((val) => {
        const valDate = new Date(val[eventDate]);
        return (
          valDate.getDate() === targetDate.getDate() &&
          valDate.getMonth() === targetDate.getMonth() &&
          valDate.getFullYear() === targetDate.getFullYear()
        );
      });
      return { eventDate: date, events: events_array.length };
    });

    
    // add 0 for days without any event
    let full_events_per_date = []
    let diff = []
    events_per_date.forEach((ev, i) => {
      if(i === 0)
        full_events_per_date.push(ev)
      else{
        const prev_date = new Date(events_per_date[i-1].eventDate)
        const currentDate = new Date(ev.eventDate)

        const days_difference = daysDifference(currentDate, prev_date)
        diff.push(days_difference)

        for(let j=1; j<days_difference; j++){
          const date_to_add = new Date(prev_date)
          date_to_add.setDate(prev_date.getDate() + j)

          full_events_per_date.push({
            eventDate: date_to_add,
            events: 0
          })
        }

        full_events_per_date.push(events_per_date[i])
          
      }
    } )

    // console.log("diff", diff)
    // console.log("full_events_per_date", full_events_per_date)
    
    return full_events_per_date
  }


  useEffect(() => {
    if (dayjs(startDate).isAfter(dayjs(endDate))) {
      setHasError(true);
    } else {
      setHasError(false);
    }
  }, [startDate, endDate]);

  const handleDateRangeSearch = () => {
    if (!hasError) {
      setNumberOfSearch(numberOfSearch + 1);
    }
  };

  return (
    <>
      {token && (
        <div className="dashboard d-flex">
          <div>
            <Sidebar />
          </div>
          <div
            style={{
              flex: "1 1 auto",
              display: "flex",
              flexFlow: "column",
              overflowY: "hidden",
              height: "100vh",
            }}
          >
            <Navbar />

            <div
              style={{
                margin: "10px",
                overflowY: "scroll",
                overflowX: "hidden",
              }}
            >
              {
                <CRow>
                  <CCol>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "10px",
                        marginRight: "25px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          width: "100%",
                          marginLeft: "25px",
                        }}
                      >
                        <div className="centered-div">{t("from")}</div>
                        <CFormInput
                          type="date"
                          id="startDate"
                          placeholder="Start Date"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          style={{
                            marginRight: "10px",
                            width: "150px",
                            height: "30px",
                            fontSize: "14px",
                            borderColor: hasError ? "red" : "",
                          }}
                        />

                        <div className="centered-div">{t("to")}</div>

                        <CFormInput
                          type="date"
                          id="endDate"
                          placeholder="End Date"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          style={{
                            marginRight: "10px",
                            width: "150px",
                            height: "30px",
                            fontSize: "14px",
                            borderColor: hasError ? "red" : "",
                          }}
                        />
                        <>
                          <CButton
                            className={`download-button ${loadingInteractions || loadingInsertions ? "outline-button" : ""}`}
                            onClick={handleDateRangeSearch}
                            style={{
                              marginRight: "10px",
                              height: "30px",
                              padding: "0 15px",
                              fontSize: "14px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border:
                                loadingInteractions || loadingInsertions
                                  ? "2px solid #204770"
                                  : "none",
                              color:
                                loadingInteractions || loadingInsertions
                                  ? "#204770"
                                  : "white",
                              backgroundColor:
                                loadingInteractions || loadingInsertions
                                  ? "transparent"
                                  : "#286F9E",
                            }}
                            onMouseEnter={(e) => {
                              if (!loadingInteractions && !loadingInsertions) {
                                e.target.style.backgroundColor = "#204770"; // Hover background color
                                e.target.style.color = "white"; // Hover text color
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (!loadingInteractions && !loadingInsertions) {
                                e.target.style.backgroundColor = "#286F9E"; // Revert to original background color
                                e.target.style.color = "white"; // Revert to original text color
                              }
                            }}
                            disabled={
                              hasError ||
                              loadingInteractions ||
                              loadingInsertions
                            } // Disable the button while loading
                          >
                            {loadingInteractions || loadingInsertions ? (
                              <ClipLoader color="#204770" size={20} />
                            ) : (
                              t("search")
                            )}
                          </CButton>
                        </>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          width: "100%",
                          marginLeft: "25px",
                        }}
                      ></div>

                      <CDropdown variant="btn-group">
                          <CDropdownToggle className="download-button" style={{
                            height: "30px",
                            width: "150px",
                            fontSize: "14px",
                          }}>{ t("downloadFiles") }</CDropdownToggle>
                          <CDropdownMenu> 
                            <CDropdownItem onClick={downloadExcel}>XLSX</CDropdownItem>
                            {/* <CDropdownItem onClick={downloadPDF}>PDF</CDropdownItem> */}
                          </CDropdownMenu>
                    </CDropdown>
                    </div>
                  </CCol>
                </CRow>
              }
              {!hasError && <div style={{ height: "10px" }}></div>}
              {hasError && (
                <CRow>
                  <div style={{ color: "red", marginLeft: "25px" }}>
                    {t("start_date_cannot_be_after_end_date")}
                  </div>
                </CRow>
              )}

              <CRow>
                <CCol md={4} lg={4} xl={4} xxl={4}>
                  <div className="card-background">
                    {!loadingTotalUsers && (
                      <CCard className="slide-card-blue height-1">
                        <div className="div-row-tooltip">
                          <Tooltip
                            title={
                              <span className="tooltip-window">
                                {t(
                                  "this_is_the_total_number_of_doctors_and_patients_regestered",
                                )}
                              </span>
                            }
                            arrow
                          >
                            <IconButton>
                              <FaInfoCircle className="info-icon-white" />
                            </IconButton>
                          </Tooltip>
                        </div>
                        <div className="rw">
                          <div className="cln">
                            <p className="widget-title">{t("totalDoctors")}</p>
                            <span>{totalDoctors}</span>
                          </div>
                          <div className="cln">
                            <p className="widget-title">{t("totalPatients")}</p>
                            <span className="widget-main-value">
                              {totalPatients}
                            </span>
                          </div>
                        </div>
                      </CCard>
                    )}
                    {loadingTotalUsers && (
                      <div className="slide-loading-card">
                        <ClipLoader
                          color="#ffffff"
                          loading={loadingTotalUsers}
                          // cssOverride={override}
                          size={80}
                          aria-label="Loading Spinner"
                          data-testid="loader"
                        />
                      </div>
                    )}
                  </div>
                </CCol>
                <CCol md={4}>
                  <div className="card-background">
                    <div className="card-background-blue">
                      <Swiper
                        spaceBetween={0}
                        //modules={[Navigation, Pagination, Scrollbar, A11y]}
                        navigation={true}
                        pagination={{ clickable: true }}
                        //scrollbar={{draggable: true}}
                        slidesPerView={1}
                        onSlideChange={() => console.log("slide change")}
                        onSwiper={(swiper) => console.log(swiper)}
                        style={{ border: "none" }}
                      >
                        <SwiperSlide>
                          <CCard className="slide-card-blue height-1">
                            <div className="div-row-tooltip">
                              <Tooltip
                                title={
                                  <span
                                    className="tooltip-window"
                                    dangerouslySetInnerHTML={{
                                      __html: t(
                                        "therapy_adherence_tooltip_info_admin",
                                      ),
                                    }}
                                  ></span>
                                }
                                arrow
                              >
                                <IconButton>
                                  <FaInfoCircle className="info-icon-white" />
                                </IconButton>
                              </Tooltip>
                            </div>
                            {!loadingAdherence && (
                              <>
                                <p className="widget-title widget-text-gold">
                                  {t("therapyAdherence")}
                                </p>
                                <span className="widget-text-white widget-main-value">
                                  {therapyAdherence.toFixed(2)}%
                                </span>
                              </>
                            )}
                            {loadingAdherence && (
                              <div className="slide-loading-card">
                                <ClipLoader
                                  color="#ffffff"
                                  loading={loadingAdherence}
                                  // cssOverride={override}
                                  size={80}
                                  aria-label="Loading Spinner"
                                  data-testid="loader"
                                />
                              </div>
                            )}
                          </CCard>
                        </SwiperSlide>
                        <SwiperSlide>
                          <CCard className="slide-card-blue height-1">
                            <div className="div-row-tooltip">
                              <Tooltip
                                title={
                                  <span
                                    className="tooltip-window"
                                    dangerouslySetInnerHTML={{
                                      __html: t("respectedAssumptions_info_admin"),
                                    }}
                                  ></span>
                                }
                                arrow
                              >
                                <IconButton>
                                  <FaInfoCircle className="info-icon-white" />
                                </IconButton>
                              </Tooltip>
                            </div>
                            {!(loadingAdherence && correctAssumptions === 0) && (
                              <>
                                <p className="widget-title widget-text-gold">
                                  {t("respectedAssumptions")}
                                </p>
                                <span className="widget-text-white widget-main-value">
                                  {`${correctAssumptions}/${totalNotifications}`}
                                </span>
                              </>
                            )}
                            {(loadingAdherence) && (
                              <div className="slide-loading-card">
                                <ClipLoader
                                  color="#ffffff"
                                  loading={(loadingAdherence ||  correctAssumptions === 0)}
                                  // cssOverride={override}
                                  size={80}
                                  aria-label="Loading Spinner"
                                  data-testid="loader"
                                />
                              </div>
                            )}
                          </CCard>
                        </SwiperSlide>
                      </Swiper>
                    </div>
                  </div>{" "}
                </CCol>
                <CCol md={4} lg={4} xl={4} xxl={4}>
                  <div className="mb-4 card-background">
                    <CCard className="slide-card-blue height-1">
                      <div className="div-row-tooltip">
                        <Tooltip
                          title={
                            <span className="tooltip-window">
                              {t("total_educational_notification_tooltip_info_admin")}
                            </span>
                          }
                          arrow
                        >
                          <IconButton>
                            <FaInfoCircle className="info-icon-white" />
                          </IconButton>
                        </Tooltip>
                      </div>
                      {!loadingTotalEducationalNotifications && (
                        <>
                          <p className="widget-title widget-text-gold">
                            {t("totalEducationalNotifications")}
                          </p>
                          <span className="widget-text-white widget-main-value">
                            {totalEducationalNotifications}
                          </span>
                        </>
                      )}
                      {loadingTotalEducationalNotifications && (
                        <div className="slide-loading-card">
                          <ClipLoader
                            color="#ffffff"
                            loading={loadingTotalEducationalNotifications}
                            size={80}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </CCard>
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol md={4} lg={4} xl={4} xxl={4}>
                  <div className="half-height">
                    <div className="card-background-blue">
                      {!loadingTotalInteractions && (
                        <Swiper
                          spaceBetween={0}
                          //modules={[Navigation, Pagination, Scrollbar, A11y]}
                          navigation={true}
                          pagination={{ clickable: true }}
                          //scrollbar={{draggable: true}}
                          slidesPerView={1}
                          onSlideChange={() => console.log("slide change")}
                          onSwiper={(swiper) => console.log(swiper)}
                          style={{ border: "none" }}
                        >
                          <SwiperSlide>
                            <CCard className="slide-card-blue height-2">
                              <div className="div-row-tooltip">
                                <Tooltip
                                  title={
                                    <span className="tooltip-window">
                                      {t("totalChatbotInteractions_info")}
                                    </span>
                                  }
                                  arrow
                                >
                                  <IconButton>
                                    <FaInfoCircle className="info-icon-white" />
                                  </IconButton>
                                </Tooltip>
                              </div>

                              <div
                                style={{
                                  paddingLeft: "25px",
                                  paddingRight: "25px",
                                }}
                              >
                                <p className="widget-title widget-text-gold">
                                  {t("totalChatbotInteractions")}
                                </p>
                              </div>
                              <span className="widget-text-white widget-main-value">
                                {totalChatbotInteractions}
                              </span>
                            </CCard>
                          </SwiperSlide>

                          <SwiperSlide>
                            <CCard className="slide-card-blue height-2">
                              <div className="div-row-tooltip">
                                <Tooltip
                                  title={
                                    <span className="tooltip-window">
                                      {t("monthlyAverageInteractions_info")}
                                    </span>
                                  }
                                  arrow
                                >
                                  <IconButton>
                                    <FaInfoCircle className="info-icon-white" />
                                  </IconButton>
                                </Tooltip>
                              </div>

                              <div
                                style={{
                                  paddingLeft: "25px",
                                  paddingRight: "25px",
                                }}
                              >
                                <p className="widget-title widget-text-gold">
                                  {t("monthlyAverageInteractions")}
                                </p>
                              </div>
                              <span className="widget-text-white widget-main-value">
                                {(
                                  totalChatbotInteractions /
                                  totalMonthlyChatbotInteractions.length
                                ).toFixed(2)}
                              </span>
                            </CCard>
                          </SwiperSlide>

                          <SwiperSlide>
                            <CCard className="slide-card-blue height-2">
                              <div className="div-row-tooltip">
                                <Tooltip
                                  title={
                                    <span className="tooltip-window">
                                      {t("dailyAverageInteractions_info")}
                                    </span>
                                  }
                                  arrow
                                >
                                  <IconButton>
                                    <FaInfoCircle className="info-icon-white" />
                                  </IconButton>
                                </Tooltip>
                              </div>

                              <div
                                style={{
                                  paddingLeft: "25px",
                                  paddingRight: "25px",
                                }}
                              >
                                <p className="widget-title widget-text-gold">
                                  {t("dailyAverageInteractions")}
                                </p>
                              </div>
                              <span className="widget-text-white widget-main-value">
                                {(
                                  totalChatbotInteractions /
                                  totalInteractionsDaysDifference
                                ).toFixed(2)}
                              </span>
                            </CCard>
                          </SwiperSlide>
                        </Swiper>
                      )}
                      {loadingTotalInteractions && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "10px",
                          }}
                        >
                          <ClipLoader
                            color="#ffffff"
                            loading={loadingTotalInteractions}
                            // cssOverride={override}
                            size={80}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="divider"></div>
                  <div className="half-height">
                    {!emptyInteraction ? (
                      <div className="card-background-blue-admin">
                        {!loadingInteractions && (
                          <Swiper
                            spaceBetween={0}
                            //modules={[Navigation, Pagination, Scrollbar, A11y]}
                            navigation={true}
                            pagination={{ clickable: true }}
                            //scrollbar={{draggable: true}}
                            slidesPerView={1}
                            onSlideChange={() => console.log("slide change")}
                            onSwiper={(swiper) => console.log(swiper)}
                            style={{ border: "none" }}
                          >
                            <SwiperSlide>
                              <CCard className="mb-4 slide-card height-2">
                                <div className="div-row-tooltip">
                                  <Tooltip
                                    title={
                                      <span className="tooltip-window">
                                        {t(
                                          "totalChatbotInteractionsInTheSelectedDateRange",
                                        )}
                                      </span>
                                    }
                                    arrow
                                  >
                                    <IconButton>
                                      <FaInfoCircle className="info-icon" />
                                    </IconButton>
                                  </Tooltip>
                                </div>

                                <div
                                  style={{
                                    paddingLeft: "25px",
                                    paddingRight: "25px",
                                  }}
                                >
                                  <p className="widget-title widget-text-gold">
                                    {t("ChatbotInteractions")}
                                  </p>
                                </div>
                                <span>
                                  {totalChatbotInteractionsInTheRangeOfDates}
                                </span>
                              </CCard>
                            </SwiperSlide>

                            <SwiperSlide>
                              <CCard className="mb-4 slide-card height-2">
                                <div className="div-row-tooltip">
                                  <Tooltip
                                    title={
                                      <span className="tooltip-window">
                                        {t(
                                          "totalChatbotInteractionsInTheSelectedDateRange_monthly",
                                        )}
                                      </span>
                                    }
                                    arrow
                                  >
                                    <IconButton>
                                      <FaInfoCircle className="info-icon" />
                                    </IconButton>
                                  </Tooltip>
                                </div>

                                <div
                                  style={{
                                    paddingLeft: "25px",
                                    paddingRight: "25px",
                                  }}
                                >
                                  <p className="widget-title widget-text-gold">
                                    {t("monthlyAverageInteractionsRange")}
                                  </p>
                                </div>
                                <span className="widget-text-white widget-main-value">
                                  {(
                                    totalChatbotInteractionsInTheRangeOfDates /
                                    monthlyChatbotInteractionsInTheRangeOfDates.length
                                  ).toFixed(2)}
                                </span>
                              </CCard>
                            </SwiperSlide>

                            <SwiperSlide>
                              <CCard className="mb-4 slide-card height-2">
                                <div className="div-row-tooltip">
                                  <Tooltip
                                    title={
                                      <span className="tooltip-window">
                                        {t(
                                          "totalChatbotInteractionsInTheSelectedDateRange_daily",
                                        )}
                                      </span>
                                    }
                                    arrow
                                  >
                                    <IconButton>
                                      <FaInfoCircle className="info-icon" />
                                    </IconButton>
                                  </Tooltip>
                                </div>

                                <div
                                  style={{
                                    paddingLeft: "25px",
                                    paddingRight: "25px",
                                  }}
                                >
                                  <p className="widget-title widget-text-gold">
                                    {t("dailyAverageInteractionsRange")}
                                  </p>
                                </div>
                                <span className="widget-text-white widget-main-value">
                                  {(
                                    totalChatbotInteractionsInTheRangeOfDates /
                                    interactionsDaysDifferenceInTheRangeOfDate
                                  ).toFixed(2)}
                                </span>
                              </CCard>
                            </SwiperSlide>
                          </Swiper>
                        )}
                        {loadingInteractions && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "10px",
                            }}
                          >
                            <ClipLoader
                              color="#204770"
                              loading={loadingInteractions}
                              // cssOverride={override}
                              size={80}
                              aria-label="Loading Spinner"
                              data-testid="loader"
                            />
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="card-background-blue-admin-no-data">
                        <p>{t("no_data_found_in_the_selected_date_range")}</p>
                      </div>
                    )}
                  </div>
                </CCol>
                <CCol md={8} lg={8} xl={8} xxl={8}>
                  {!emptyInteraction ? (
                    <CCard className="card-graph">
                      {!(loadingTotalInteractions && loadingInteractions) && (
                        <Line
                          data={interactionData}
                          options={interactionOptions}
                        />
                      )}
                      {loadingTotalInteractions && loadingInteractions && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "10px",
                            height: "100%",
                          }}
                        >
                          <ClipLoader
                            color="#204770"
                            loading={
                              loadingTotalInteractions && loadingInteractions
                            }
                            size={100}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </CCard>
                  ) : (
                    <div className="no-data-admin">
                      <p>{t("no_data_found_in_the_selected_date_range")}</p>
                    </div>
                  )}
                </CCol>
              </CRow>
              <div style={{ height: "20px" }}></div>
              <CRow>
                <CCol md={4} lg={4} xl={4} xxl={4}>
                  <div className="half-height">
                    <div className="card-background-blue">
                      {!loadingTotalInsertions && (
                        <Swiper
                          spaceBetween={0}
                          //modules={[Navigation, Pagination, Scrollbar, A11y]}
                          navigation={true}
                          pagination={{ clickable: true }}
                          //scrollbar={{draggable: true}}
                          slidesPerView={1}
                          onSlideChange={() => console.log("slide change")}
                          onSwiper={(swiper) => console.log(swiper)}
                          style={{ border: "none" }}
                        >
                          <SwiperSlide>
                            <CCard className="slide-card-blue height-2">
                              <div className="div-row-tooltip">
                                <Tooltip
                                  title={
                                    <span className="tooltip-window">
                                      {t("totalInsertions_info")}
                                    </span>
                                  }
                                  arrow
                                >
                                  <IconButton>
                                    <FaInfoCircle className="info-icon-white" />
                                  </IconButton>
                                </Tooltip>
                              </div>

                              <div
                                style={{
                                  paddingLeft: "25px",
                                  paddingRight: "25px",
                                }}
                              >
                                <p className="widget-title widget-text-gold">
                                  {t("totalBloodPressureInsertions")}
                                </p>
                              </div>
                              <span className="widget-text-white widget-main-value">
                                {totalPressureInsertions}
                              </span>
                            </CCard>
                          </SwiperSlide>
                          <SwiperSlide>
                            <CCard className="slide-card-blue height-2">
                              <div className="div-row-tooltip">
                                <Tooltip
                                  title={
                                    <span className="tooltip-window">
                                      {t("monthlyAverageInsertions_info")}
                                    </span>
                                  }
                                  arrow
                                >
                                  <IconButton>
                                    <FaInfoCircle className="info-icon-white" />
                                  </IconButton>
                                </Tooltip>
                              </div>

                              <div
                                style={{
                                  paddingLeft: "25px",
                                  paddingRight: "25px",
                                }}
                              >
                                <p className="widget-title widget-text-gold">
                                  {t("monthlyAverageInsertions")}
                                </p>
                              </div>
                              <span className="widget-text-white widget-main-value">
                                {(
                                  totalPressureInsertions /
                                  totalMonthlyInsertions.length
                                ).toFixed(2)}
                              </span>
                            </CCard>
                          </SwiperSlide>
                          <SwiperSlide>
                            <CCard className="slide-card-blue height-2">
                              <div className="div-row-tooltip">
                                <Tooltip
                                  title={
                                    <span className="tooltip-window">
                                      {t("dailyAverageInsertions_info")}
                                    </span>
                                  }
                                  arrow
                                >
                                  <IconButton>
                                    <FaInfoCircle className="info-icon-white" />
                                  </IconButton>
                                </Tooltip>
                              </div>

                              <div
                                style={{
                                  paddingLeft: "25px",
                                  paddingRight: "25px",
                                }}
                              >
                                <p className="widget-title widget-text-gold">
                                  {t("dailyAverageInsertions")}
                                </p>
                              </div>
                              <span className="widget-text-white widget-main-value">
                                {(
                                  totalPressureInsertions /
                                  totalInsertionsDaysDifference
                                ).toFixed(2)}
                              </span>
                            </CCard>
                          </SwiperSlide>
                        </Swiper>
                      )}
                      {loadingTotalInsertions && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "10px",
                          }}
                        >
                          <ClipLoader
                            color="#ffffff"
                            loading={loadingTotalInsertions}
                            // cssOverride={override}
                            size={80}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="divider"></div>
                  <div className="half-height">
                    {!emptyInsertion ? (
                      <div className="card-background-blue-admin">
                        {!loadingInsertions && (
                          <Swiper
                            spaceBetween={0}
                            //modules={[Navigation, Pagination, Scrollbar, A11y]}
                            navigation={true}
                            pagination={{ clickable: true }}
                            //scrollbar={{draggable: true}}
                            slidesPerView={1}
                            onSlideChange={() => console.log("slide change")}
                            onSwiper={(swiper) => console.log(swiper)}
                            style={{ border: "none" }}
                          >
                            <SwiperSlide>
                              <CCard className="mb-4 slide-card height-2">
                                <div className="div-row-tooltip">
                                  <Tooltip
                                    title={
                                      <span className="tooltip-window">
                                        {t("insertionsRange_info")}
                                      </span>
                                    }
                                    arrow
                                  >
                                    <IconButton>
                                      <FaInfoCircle className="info-icon" />
                                    </IconButton>
                                  </Tooltip>
                                </div>

                                <div
                                  style={{
                                    paddingLeft: "25px",
                                    paddingRight: "25px",
                                  }}
                                >
                                  <p className="widget-title widget-text-gold">
                                    {t("insertionsRange")}
                                  </p>
                                </div>

                                <span className="widget-text-white widget-main-value">
                                  {pressureInsertionsInTheRangeOfDate}
                                </span>
                              </CCard>
                            </SwiperSlide>
                            <SwiperSlide>
                              <CCard className="mb-4 slide-card height-2">
                                <div className="div-row-tooltip">
                                  <Tooltip
                                    title={
                                      <span className="tooltip-window">
                                        {t("monthlyInsertionsRange_info")}
                                      </span>
                                    }
                                    arrow
                                  >
                                    <IconButton>
                                      <FaInfoCircle className="info-icon" />
                                    </IconButton>
                                  </Tooltip>
                                </div>

                                <p className="widget-title widget-text-gold">
                                  {t("monthlyInsertionsRange")}
                                </p>
                                <span className="widget-text-white widget-main-value">
                                  {(
                                    pressureInsertionsInTheRangeOfDate /
                                    monthlyInsertionsInTheRangeOfDates.length
                                  ).toFixed(2)}
                                </span>
                              </CCard>
                            </SwiperSlide>
                            <SwiperSlide>
                              <CCard className="mb-4 slide-card height-2">
                                <div className="div-row-tooltip">
                                  <Tooltip
                                    title={
                                      <span className="tooltip-window">
                                        {t("dailyInsertionsRange_info")}
                                      </span>
                                    }
                                    arrow
                                  >
                                    <IconButton>
                                      <FaInfoCircle className="info-icon" />
                                    </IconButton>
                                  </Tooltip>
                                </div>

                                <div
                                  style={{
                                    paddingLeft: "25px",
                                    paddingRight: "25px",
                                  }}
                                >
                                  <p className="widget-title widget-text-gold">
                                    {t("dailyInsertionsRange")}
                                  </p>
                                </div>
                                <span className="widget-text-white widget-main-value">
                                  {(
                                    pressureInsertionsInTheRangeOfDate /
                                    insertionsDaysDifferenceInTheRangeOfDate
                                  ).toFixed(2)}
                                </span>
                              </CCard>
                            </SwiperSlide>
                          </Swiper>
                        )}
                        {loadingInsertions && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "10px",
                            }}
                          >
                            <ClipLoader
                              color="#204770"
                              loading={loadingInsertions}
                              // cssOverride={override}
                              size={80}
                              aria-label="Loading Spinner"
                              data-testid="loader"
                            />
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="card-background-blue-admin-no-data">
                        <p>{t("no_data_found_in_the_selected_date_range")}</p>
                      </div>
                    )}
                  </div>
                </CCol>
                <CCol md={8} lg={8} xl={8} xxl={8}>
                  {!emptyInsertion ? (
                    <CCard className="card-graph">
                      {!(loadingTotalInsertions && loadingInsertions) && (
                        <Line data={insertionData} options={insertionOptions} />
                      )}
                      {loadingTotalInsertions && loadingInsertions && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "10px",
                            height: "100%",
                          }}
                        >
                          <ClipLoader
                            color="#204770"
                            loading={
                              loadingTotalInsertions && loadingInsertions
                            }
                            // cssOverride={override}
                            size={100}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </CCard>
                  ) : (
                    <div className="no-data-admin">
                      <p>{t("no_data_found_in_the_selected_date_range")}</p>
                    </div>
                  )}
                </CCol>
              </CRow>
            </div>
          </div>
        </div>
      )}

      {!token && <div className="login-container"></div>}
      <LogoutModal
        show={showLogoutModal}
        handleConfirm={handleConfirm}
        handleClose={handleConfirm}
        title={t("login")}
        message={t("session_expired_please_login_again")}
        tag={"Login"}
      />
    </>
  );
};

export default DashboardAdmin;
